import { appPath } from './appPath';
import { companyUrl, platformUrl } from './mhNav';

const PORTAL_KEY = 'mhLastPortal';

/** URL for the sign-in screen (respects CRA `PUBLIC_URL`). */
export function loginPath() {
  return appPath('/login');
}

/** Remember which admin UI the user prefers for post-login & root redirect. */
export function setPreferredPortal(portal) {
  if (portal === 'platform' || portal === 'company') {
    localStorage.setItem(PORTAL_KEY, portal);
  }
}

export function getPreferredPortal() {
  const v = localStorage.getItem(PORTAL_KEY);
  return v === 'platform' ? 'platform' : 'company';
}

export function defaultDashboardPath() {
  return getPreferredPortal() === 'platform' ? platformUrl('dashboard') : companyUrl('dashboard');
}

/** Clear session and go to login (full navigation so all state resets). */
export function performLogout() {
  localStorage.removeItem('login');
  localStorage.removeItem('authenticated');
  localStorage.removeItem('authToken');
  localStorage.removeItem('token');
  localStorage.removeItem('access_token');
  window.location.assign(loginPath());
}
